export enum Arrows {
  Next = 'next',
  Previous = 'previous'
}
